// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {initializeAppCheck, ReCaptchaV3Provider} from "firebase/app-check";
import {getAuth} from "firebase/auth";
import {getFirestore, enableIndexedDbPersistence} from "firebase/firestore";
import {getStorage} from "firebase/storage";
import {getFunctions} from "firebase/functions";
import {getAnalytics, isSupported} from "firebase/analytics";
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAfPgIyJRK9_Cu8awi5jeTQ4NXu3nwrYpw",
    authDomain: "spenza-recipe-app.firebaseapp.com",
    projectId: "spenza-recipe-app",
    storageBucket: "spenza-recipe-app.appspot.com",
    messagingSenderId: "1002872122808",
    appId: "1:1002872122808:web:b5baa8efc3fcc0fbad334d",
    measurementId: "G-N5196MJMJW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase App Check (reCAPTCHA v3). No-op until REACT_APP_APPCHECK_SITE_KEY is
// set, so dev/local builds are unaffected. Create the site key in the Firebase
// console (App Check > Web app > reCAPTCHA v3) and add it to .env, then deploy.
// Enable ENFORCEMENT in the console only AFTER clients ship tokens (monitor first).
const appCheckSiteKey = process.env.REACT_APP_APPCHECK_SITE_KEY;
if (typeof window !== 'undefined' && appCheckSiteKey) {
    try {
        initializeAppCheck(app, {
            provider: new ReCaptchaV3Provider(appCheckSiteKey),
            isTokenAutoRefreshEnabled: true,
        });
    } catch (e) {
        // Never let App Check init break app startup.
        // eslint-disable-next-line no-console
        console.warn('App Check init failed:', e);
    }
}

// GA4 analytics — initialised only where supported (skips SSR/unsupported envs).
let analytics = null;
isSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app);
}).catch(() => {});
const getAnalyticsInstance = () => analytics;

const auth = getAuth(app);
const db = getFirestore(app);
// Cache reads in IndexedDB so repeat loads / navigations serve from the local
// cache instantly (and the app keeps working offline) instead of round-tripping
// to Firestore every time — mirrors the mobile app's on-device cache. Best-effort:
// failed-precondition = another tab already holds the single-tab lease;
// unimplemented = the browser can't do IndexedDB (e.g. private mode). Both are
// non-fatal — the app just falls back to network-only reads.
if (typeof window !== 'undefined') {
    enableIndexedDbPersistence(db).catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('Firestore offline persistence unavailable:', err && err.code);
    });
}
const storage = getStorage(app);
const functions = getFunctions(app, 'australia-southeast1');

export {auth, db, storage, functions, getAnalyticsInstance};